import React from 'react'

export const Time = (props) => {

  let [state, setState] = React.useState({
    time: 0,
  })
  const intervalRef = React.useRef(null);
  //const th = 1000* 60 * 60 * 1.5;
  const th = 1000* 60 * 60 * 1.5; //0.003

  function convertMsToHM(milliseconds) {
    let seconds = Math.floor(milliseconds / 1000);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);

    seconds = seconds % 60;
    minutes = minutes % 60;
    hours = hours % 24;

    return `${addZeroBefore(hours)}:${addZeroBefore(minutes)}:${addZeroBefore(seconds)}`;
  }




  React.useEffect(() => {
    intervalRef.current = setInterval(() => {
      let tl = th - (new Date().getTime() - props.starttime);
      if (tl >= 0){
        setState(prevState => ({
          ...prevState,
          time: tl
        }));
      }
      else{
        clearInterval(intervalRef.current);
        props.onTimeIsOver();
      }
    }, 500);

    return () => clearInterval(intervalRef.current);
  }, [props.starttime])

  React.useEffect(() => {
    if(props.room >= 7){
      console.log("useEffect room timerId: ", intervalRef.current)
      clearInterval(intervalRef.current);
      props.onStopTime(state.time)
    }

  }, [props.room])

  const addZeroBefore = (n) => {
    return (n < 10 ? '0' : '') + n;
  }

  return(
    <div className={`clock ${(props.room >= 7) ? "hide" : ""}`}>
      <div className="digital">
        {convertMsToHM(state.time)}
      </div>
      <div className="penality">{props.penality}</div>
    </div>
  )
}
